/**
 * 轮播图模块
 * 支持自动播放、触摸滑动、键盘导航
 */
export function initCarousel() {
  const carousels = document.querySelectorAll('.carousel');
  if (carousels.length === 0) return;

  // 标记轮播是否已初始化
  let carouselInitialized = false;

  // 统计图片加载状态
  let loadedImages = 0;
  let totalImages = 0;

  carousels.forEach(carousel => {
    totalImages += carousel.querySelectorAll('img').length;
  });

  // 如果没有图片，直接初始化
  if (totalImages === 0) {
    setup();
    return;
  }

  // 为所有轮播图片添加加载事件
  carousels.forEach(carousel => {
    carousel.querySelectorAll('img').forEach(img => {
      if (img.complete && img.naturalWidth !== 0) {
        loadedImages++;
        checkAllImagesLoaded();
      } else {
        img.addEventListener('load', () => {
          loadedImages++;
          checkAllImagesLoaded();
        });
        img.addEventListener('error', () => {
          loadedImages++;
          checkAllImagesLoaded();
        });
      }
    });
  });

  // 检查是否所有图片都已加载
  function checkAllImagesLoaded() {
    if (loadedImages >= totalImages && !carouselInitialized) {
      setup();
    }
  }

  // window.load 备份方案
  window.addEventListener('load', () => {
    setTimeout(() => {
      if (!carouselInitialized) {
        setup();
      }
    }, 1000);
  });

  // 立即检查一次（可能全部已缓存）
  checkAllImagesLoaded();

  function setup() {
    if (carouselInitialized) return;
    carouselInitialized = true;

    carousels.forEach(carousel => {
      const items = carousel.querySelectorAll('.carousel-item');
      const totalItems = items.length;
      if (totalItems === 0) return;

      let currentIndex = 0;

      // 检查是否是首页的特殊轮播图（一个 item 中有多个图片）
      const isHomePage = items[0].querySelectorAll('img').length > 1;

      // 初始化：移除所有 active，激活第一个
      items.forEach(item => item.classList.remove('active'));
      items[0].classList.add('active');

      function showNextItem() {
        items[currentIndex].classList.remove('active');
        currentIndex = (currentIndex + 1) % totalItems;
        items[currentIndex].classList.add('active');
      }

      function showPrevItem() {
        items[currentIndex].classList.remove('active');
        currentIndex = (currentIndex - 1 + totalItems) % totalItems;
        items[currentIndex].classList.add('active');
      }

      // 自动播放
      let autoPlayTimer = null;

      function startAutoPlay() {
        if (totalItems > 1 || isHomePage) {
          autoPlayTimer = setInterval(showNextItem, 4000);
        }
      }

      function stopAutoPlay() {
        if (autoPlayTimer) {
          clearInterval(autoPlayTimer);
          autoPlayTimer = null;
        }
      }

      startAutoPlay();

      // ========== 触摸滑动支持 ==========
      let touchStartX = 0;
      let touchEndX = 0;
      let isDragging = false;

      carousel.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
        isDragging = true;
        stopAutoPlay();
      }, { passive: true });

      carousel.addEventListener('touchmove', () => {
        // 预留实时拖拽效果扩展
      }, { passive: true });

      carousel.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        isDragging = false;
        touchEndX = e.changedTouches[0].screenX;
        const diff = touchStartX - touchEndX;

        // 最小滑动距离 50px
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            showNextItem();
          } else {
            showPrevItem();
          }
        }

        startAutoPlay();
      }, { passive: true });

      // ========== 键盘导航支持 ==========
      document.addEventListener('keydown', (e) => {
        const rect = carousel.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
        if (!isVisible) return;

        if (e.key === 'ArrowLeft') {
          stopAutoPlay();
          showPrevItem();
          startAutoPlay();
        } else if (e.key === 'ArrowRight') {
          stopAutoPlay();
          showNextItem();
          startAutoPlay();
        }
      });
    });
  }
}
